import React from 'react'
import { Button } from 'antd'
import { TradingAccountCountryDto } from 'api/Trading-Accounts/Types/TradingAccountCountryDto'
import { UpdateTradingAccountCountry } from 'api/Trading-Accounts/Types/UpdateTradingAccountCountry'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikProps, withFormik } from 'formik'
import { FormSubmitValues } from 'utils/formValidation'

const EditCountryFormUI: React.FC<
  FormikProps<UpdateTradingAccountCountryFormValues> & OuterProps
> = (props) => {
  const { handleSubmit, isSubmitting } = props

  const onSubmit = () => {
    props.setSubmitting(true)
    handleSubmit()
  }

  return (
    <FormBaseContainer>
      <Form>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Demo Account Allowed</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='demoAccountAllowed' type='checkbox' />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Welcome Account Allowed</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='welcomeAccountAllowed' type='checkbox' />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseButtonContainer>
          <Button onClick={onSubmit} disabled={isSubmitting} key='button' htmlType='button'>
            Submit
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

type UpdateTradingAccountCountryFormValues = UpdateTradingAccountCountry

interface OuterProps {
  data: TradingAccountCountryDto

  onSubmit(values: FormSubmitValues<UpdateTradingAccountCountryFormValues>): void
}

export const EditTradingAccountCountryForm = withFormik<
  OuterProps,
  UpdateTradingAccountCountryFormValues
>({
  mapPropsToValues: ({ data }) => {
    return {
      demoAccountAllowed: data.demoAccountAllowed,
      welcomeAccountAllowed: data.welcomeAccountAllowed,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(values)
      setSubmitting(false)
    } catch (e) {
      console.error(e)
      setSubmitting(false)
    }
  },
})(EditCountryFormUI)
